export const CLIENTS_KEYS = {
  all: ['clients'] as const,
  byOrg: (orgId: string) => ['clients', orgId] as const,
  list: (orgId: string, search: string) => ['clients', orgId, 'list', search] as const,
  detail: (orgId: string, id: string) => ['clients', orgId, 'detail', id] as const,
};
